/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onCloseAddPop, tcidParent } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState(tcidParent);
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [birth, setBirth] = useState("");
  const [sex, setSex] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");  

  const onSubmit = async () => {
    // pr("tcid=" + tcid);
    // pr("name=" + name);
    // pr("pass1=" + pass1);
    // pr("birth=" + birth);
    // pr("sex=" + sex);
    // pr("height=" + height);
    // pr("weight=" + weight);
    let result = await axios.post(configState.api + "/gympass_admin/member_add", {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        tcid: tcid,
        name:name,
        phone:phone,
        pass1:pass1,
        pass2:pass2,
        birth:birth,
        sex:sex,
        height:height,
        weight:weight,
    });
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onCloseAddPop();
        }
      );
    }
  };

  const onCidChange = (e) => {
    pr("cid change");
  };

  const handleClose = () => {};

  // MemberSearch
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  return (
    <Box>
      {/* 사용자 찾기 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </Dialog>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        
        {/* 센터명 */}
        <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />     

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></TextField>
        </Box>

        {/* 연락처 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
          display="flex"
          alignItems="center"
        >
          <TextField
            name="phone"
            label="연락처"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          ></TextField>
          <Box sx={{ ml: 1 }}>- 없이 숫자만 입력</Box>
        </Box>

        {/* 비밀번호 */}
        <Box
          display="flex"
          alignItems="center"
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            type="password"
            name="pass1"
            label="비밀번호"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={pass1}
            onChange={(e) => setPass1(e.target.value)}
          ></TextField>
          <Box sx={{ ml: 1 }}>4~12자리 영문과 숫자로 입력</Box>
        </Box>
        
        {/* 비밀번호 확인 */}
        <Box
          display="flex"
          alignItems="center"
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            type="password"
            name="pass2"
            label="비밀번호 확인"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={pass2}
            onChange={(e) => setPass2(e.target.value)}
          ></TextField>
          <Box sx={{ ml: 1 }}>4~12자리 영문과 숫자로 입력</Box>
        </Box>        

        {/* 생일 */}
        <Box
          display="flex"
          alignItems="center"
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="birth"
            label="생일"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={birth}
            onChange={(e) => setBirth(e.target.value)}
          ></TextField>
          <Box sx={{ ml: 1 }}>0000-00-00 형식으로 입력</Box>
        </Box>

        {/* 성별 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>성별</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="sex"
            onChange={(e)=>setSex(e.target.value)}
            value={sex}
          >
            <FormControlLabel value="남" control={<Radio />} label="남" />
            <FormControlLabel value="여" control={<Radio />} label="여" />
          </RadioGroup>
        </FormControl>

        {/* 키 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="height"
            label="키"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
          ></TextField>
          <TextField
            name="weight"
            label="몸무게"
            size="small"
            sx={{
              ml:1,
              width: "180px",
            }}
            autoComplete="off"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
          ></TextField>
        </Box>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onCloseAddPop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
